import {Market} from './model/market';

export const Markets: Market[] = [

{id: 1,	iso: 'AF', name: 'AFGHANISTAN'},
{id: 2,	iso: 'AL', name: 'ALBANIA'},
{id: 3,	iso: 'DZ', name: 'ALGERIA'},
{id: 4,	iso: 'AS', name: 'AMERICAN SAMOA'},
{id: 5,	iso: 'AD', name: 'ANDORRA'},
{id: 6,	iso: 'AO', name: 'ANGOLA'},
{id: 7,	iso: 'AI', name: 'ANGUILLA'},
{id: 8,	iso: 'AQ', name: 'ANTARCTICA'},
{id: 9,	iso: 'AG', name: 'ANTIGUA AND BARBUDA'},
{id: 10,	iso: 'AR', name: 'ARGENTINA'},
{id: 11,	iso: 'AM', name: 'ARMENIA'},
{id: 12,	iso: 'AW', name: 'ARUBA'},
{id: 13,	iso: 'AU', name: 'AUSTRALIA'},
{id: 14,	iso: 'AT', name: 'AUSTRIA'},
{id: 15,	iso: 'AZ', name: 'AZERBAIJAN'},
{id: 16,	iso: 'BS', name: 'BAHAMAS'},
{id: 17,	iso: 'BH', name: 'BAHRAIN'},
{id: 18,	iso: 'BD', name: 'BANGLADESH'},
{id: 19,	iso: 'BB', name: 'BARBADOS'},
{id: 20,	iso: 'BY', name: 'BELARUS'},
{id: 21,	iso: 'BE', name: 'BELGIUM'},
{id: 22,	iso: 'BZ', name: 'BELIZE'},
{id: 23,	iso: 'BJ', name: 'BENIN'},
{id: 24,	iso: 'BM', name: 'BERMUDA'},
{id: 25,	iso: 'BT', name: 'BHUTAN'},
{id: 26,	iso: 'BO', name: 'BOLIVIA'},
{id: 27,	iso: 'BA', name: 'BOSNIA AND HERZEGOVINA'},
{id: 28,	iso: 'BW', name: 'BOTSWANA'},
{id: 29,	iso: 'BV', name: 'BOUVET ISLAND'},
{id: 30,	iso: 'BR', name: 'BRAZIL'},
{id: 31,	iso: 'IO', name: 'BRITISH INDIAN OCEAN TERRITORY'},
{id: 32,	iso: 'BN', name: 'BRUNEI DARUSSALAM'},
{id: 33,	iso: 'BG', name: 'BULGARIA'},
{id: 34,	iso: 'BF', name: 'BURKINA FASO'},
{id: 35,	iso: 'BI', name: 'BURUNDI'},
{id: 36,	iso: 'KH', name: 'CAMBODIA'},
{id: 37,	iso: 'CM', name: 'CAMEROON'},
{id: 38,	iso: 'CA', name: 'CANADA'},
{id: 39,	iso: 'CV', name: 'CAPE VERDE'},
{id: 40,	iso: 'KY', name: 'CAYMAN ISLANDS'},
{id: 41,	iso: 'CF', name: 'CENTRAL AFRICAN REPUBLIC'},
{id: 42,	iso: 'TD', name: 'CHAD'},
{id: 43,	iso: 'CL', name: 'CHILE'},
{id: 44,	iso: 'CN', name: 'CHINA'},
{id: 45,	iso: 'CX', name: 'CHRISTMAS ISLAND'},
{id: 46,	iso: 'CC', name: 'COCOS (KEELING) ISLANDS'},
{id: 47,	iso: 'CO', name: 'COLOMBIA'},
{id: 48,	iso: 'KM', name: 'COMOROS'},
{id: 49,	iso: 'CG', name: 'CONGO'},
{id: 50,	iso: 'CD', name: 'THE DEMOCRATIC REPUBLIC OF THE CONGO'},
{id: 51,	iso: 'CK', name: 'COOK ISLANDS'},
{id: 52,	iso: 'CR', name: 'COSTA RICA'},
{id: 53,	iso: 'CI', name: 'COTE DIVOIRE'},
{id: 54,	iso: 'HR', name: 'CROATIA'},
{id: 55,	iso: 'CU', name: 'CUBA'},
{id: 56,	iso: 'CY', name: 'CYPRUS'},
{id: 57,	iso: 'CZ', name: 'CZECH REPUBLIC'},
{id: 58,	iso: 'DK', name: 'DENMARK'},
{id: 59,	iso: 'DJ', name: 'DJIBOUTI'},
{id: 60,	iso: 'DM', name: 'DOMINICA'},
{id: 61,	iso: 'DO', name: 'DOMINICAN REPUBLIC'},
{id: 62,	iso: 'EC', name: 'ECUADOR'},
{id: 63,	iso: 'EG', name: 'EGYPT'},
{id: 64,	iso: 'SV', name: 'EL SALVADOR'},
{id: 65,	iso: 'GQ', name: 'EQUATORIAL GUINEA'},
{id: 66,	iso: 'ER', name: 'ERITREA'},
{id: 67,	iso: 'EE', name: 'ESTONIA'},
{id: 68,	iso: 'ET', name: 'ETHIOPIA'},
{id: 69,	iso: 'FK', name: 'FALKLAND ISLANDS (MALVINAS)'},
{id: 70,	iso: 'FO', name: 'FAROE ISLANDS'},
{id: 71,	iso: 'FJ', name: 'FIJI'},
{id: 72,	iso: 'FI', name: 'FINLAND'},
{id: 73,	iso: 'FR', name: 'FRANCE'},
{id: 74,	iso: 'GF', name: 'FRENCH GUIANA'},
{id: 75,	iso: 'PF', name: 'FRENCH POLYNESIA'},
{id: 76,	iso: 'TF', name: 'FRENCH SOUTHERN TERRITORIES'},
{id: 77,	iso: 'GA', name: 'GABON'},
{id: 78,	iso: 'GM', name: 'GAMBIA'},
{id: 79,	iso: 'GE', name: 'GEORGIA'},
{id: 80,	iso: 'DE', name: 'GERMANY'},
{id: 81,	iso: 'GH', name: 'GHANA'},
{id: 82,	iso: 'GI', name: 'GIBRALTAR'},
{id: 83,	iso: 'GR', name: 'GREECE'},
{id: 84,	iso: 'GL', name: 'GREENLAND'},
{id: 85,	iso: 'GD', name: 'GRENADA'},
{id: 86,	iso: 'GP', name: 'GUADELOUPE'},
{id: 87,	iso: 'GU', name: 'GUAM'},
{id: 88,	iso: 'GT', name: 'GUATEMALA'},
{id: 89,	iso: 'GN', name: 'GUINEA'},
{id: 90,	iso: 'GW', name: 'GUINEA-BISSAU'},
{id: 91,	iso: 'GY', name: 'GUYANA'},
{id: 92,	iso: 'HT', name: 'HAITI'},
{id: 93,	iso: 'HM', name: 'HEARD ISLAND AND MCDONALD ISLANDS'},
{id: 94,	iso: 'VA', name: 'HOLY SEE (VATICAN CITY STATE)'},
{id: 95,	iso: 'HN', name: 'HONDURAS'},
{id: 96,	iso: 'HK', name: 'HONG KONG'},
{id: 97,	iso: 'HU', name: 'HUNGARY'},
{id: 98,	iso: 'IS', name: 'ICELAND'},
{id: 99,	iso: 'IN', name: 'INDIA'},
{id: 100, iso: 'ID', name: 'INDONESIA'},
{id: 101, iso: 'IR', name: 'IRAN'},
{id: 102, iso: 'IQ', name: 'IRAQ'},
{id: 103, iso: 'IE', name: 'IRELAND'},
{id: 104, iso: 'IL', name: 'ISRAEL'},
{id: 105, iso: 'IT', name: 'ITALY'},
{id: 106, iso: 'JM', name: 'JAMAICA'},
{id: 107, iso: 'JP', name: 'JAPAN'},
{id: 108, iso: 'JO', name: 'JORDAN'},
{id: 109, iso: 'KZ', name: 'KAZAKHSTAN'},
{id: 110, iso: 'KE', name: 'KENYA'},
{id: 111, iso: 'KI', name: 'KIRIBATI'},
{id: 112, iso: 'KP', name: 'DEMOCRATIC PEOPLES REPUBLIC OF KOREA'},
{id: 113, iso: 'KR', name: 'REPUBLIC OF KOREA'},
{id: 114, iso: 'KW', name: 'KUWAIT'},
{id: 115, iso: 'KG', name: 'KYRGYZSTAN'},
{id: 116, iso: 'LA', name: 'LAO PEOPLES DEMOCRATIC REPUBLIC'},
{id: 117, iso: 'LV', name: 'LATVIA'},
{id: 118, iso: 'LB', name: 'LEBANON'},
{id: 119, iso: 'LS', name: 'LESOTHO'},
{id: 120, iso: 'LR', name: 'LIBERIA'},
{id: 121, iso: 'LY', name: 'LIBYAN ARAB JAMAHIRIYA'},
{id: 122, iso: 'LI', name: 'LIECHTENSTEIN'},
{id: 123, iso: 'LT', name: 'LITHUANIA'},
{id: 124, iso: 'LU', name: 'LUXEMBOURG'},
{id: 125, iso: 'MO', name: 'MACAO'},
{id: 126, iso: 'MK', name: 'MACEDONIA'},
{id: 127, iso: 'MG', name: 'MADAGASCAR'},
{id: 128, iso: 'MW', name: 'MALAWI'},
{id: 129, iso: 'MY', name: 'MALAYSIA'},
{id: 130, iso: 'MV', name: 'MALDIVES'},
{id: 131, iso: 'ML', name: 'MALI'},
{id: 132, iso: 'MT', name: 'MALTA'},
{id: 133, iso: 'MH', name: 'MARSHALL ISLANDS'},
{id: 134, iso: 'MQ', name: 'MARTINIQUE'},
{id: 135, iso: 'MR', name: 'MAURITANIA'},
{id: 136, iso: 'MU', name: 'MAURITIUS'},
{id: 137, iso: 'YT', name: 'MAYOTTE'},
{id: 138, iso: 'MX', name: 'MEXICO'},
{id: 139, iso: 'FM', name: 'MICRONESIA'},
{id: 140, iso: 'MD', name: 'MOLDOVA'},
{id: 141, iso: 'MC', name: 'MONACO'},
{id: 142, iso: 'MN', name: 'MONGOLIA'},
{id: 143, iso: 'MS', name: 'MONTSERRAT'},
{id: 144, iso: 'MA', name: 'MOROCCO'},
{id: 145, iso: 'MZ', name: 'MOZAMBIQUE'},
{id: 146, iso: 'MM', name: 'MYANMAR'},
{id: 147, iso: 'NA', name: 'NAMIBIA'},
{id: 148, iso: 'NR', name: 'NAURU'},
{id: 149, iso: 'NP', name: 'NEPAL'},
{id: 150, iso: 'NL', name: 'NETHERLANDS'},
{id: 151, iso: 'AN', name: 'NETHERLANDS ANTILLES'},
{id: 152, iso: 'NC', name: 'NEW CALEDONIA'},
{id: 153, iso: 'NZ', name: 'NEW ZEALAND'},
{id: 154, iso: 'NI', name: 'NICARAGUA'},
{id: 155, iso: 'NE', name: 'NIGER'},
{id: 156, iso: 'NG', name: 'NIGERIA'},
{id: 157, iso: 'NU', name: 'NIUE'},
{id: 158, iso: 'NF', name: 'NORFOLK ISLAND'},
{id: 159, iso: 'MP', name: 'NORTHERN MARIANA ISLANDS'},
{id: 160, iso: 'NO', name: 'NORWAY'},
{id: 161, iso: 'OM', name: 'OMAN'},
{id: 162, iso: 'PK', name: 'PAKISTAN'},
{id: 163, iso: 'PW', name: 'PALAU'},
{id: 164, iso: 'PS', name: 'PALESTINIAN TERRITORY'},
{id: 165, iso: 'PA', name: 'PANAMA'},
{id: 166, iso: 'PG', name: 'PAPUA NEW GUINEA'},
{id: 167, iso: 'PY', name: 'PARAGUAY'},
{id: 168, iso: 'PE', name: 'PERU'},
{id: 169, iso: 'PH', name: 'PHILIPPINES'},
{id: 170, iso: 'PN', name: 'PITCAIRN'},
{id: 171, iso: 'PL', name: 'POLAND'},
{id: 172, iso: 'PT', name: 'PORTUGAL'},
{id: 173, iso: 'PR', name: 'PUERTO RICO'},
{id: 174, iso: 'QA', name: 'QATAR'},
{id: 175, iso: 'RE', name: 'REUNION'},
{id: 176, iso: 'RO', name: 'ROMANIA'},
{id: 177, iso: 'RU', name: 'RUSSIA'},
{id: 178, iso: 'RW', name: 'RWANDA'},
{id: 179, iso: 'SH', name: 'SAINT HELENA'},
{id: 180, iso: 'KN', name: 'SAINT KITTS AND NEVIS'},
{id: 181, iso: 'LC', name: 'SAINT LUCIA'},
{id: 182, iso: 'PM', name: 'SAINT PIERRE AND MIQUELON'},
{id: 183, iso: 'VC', name: 'SAINT VINCENT AND THE GRENADINES'},
{id: 184, iso: 'WS', name: 'SAMOA'},
{id: 185, iso: 'SM', name: 'SAN MARINO'},
{id: 186, iso: 'ST', name: 'SAO TOME AND PRINCIPE'},
{id: 187, iso: 'SA', name: 'SAUDI ARABIA'},
{id: 188, iso: 'SN', name: 'SENEGAL'},
{id: 189, iso: 'CS', name: 'SERBIA AND MONTENEGRO'},
{id: 190, iso: 'SC', name: 'SEYCHELLES'},
{id: 191, iso: 'SL', name: 'SIERRA LEONE'},
{id: 192, iso: 'SG', name: 'SINGAPORE'},
{id: 193, iso: 'SK', name: 'SLOVAKIA'},
{id: 194, iso: 'SI', name: 'SLOVENIA'},
{id: 195, iso: 'SB', name: 'SOLOMON ISLANDS'},
{id: 196, iso: 'SO', name: 'SOMALIA'},
{id: 197, iso: 'ZA', name: 'SOUTH AFRICA'},
{id: 198, iso: 'GS', name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'},
{id: 199, iso: 'ES', name: 'SPAIN'},
{id: 200, iso: 'LK', name: 'SRI LANKA'},
{id: 201, iso: 'SD', name: 'SUDAN'},
{id: 202, iso: 'SR', name: 'SURINAME'},
{id: 203, iso: 'SJ', name: 'SVALBARD AND JAN MAYEN'},
{id: 204, iso: 'SZ', name: 'SWAZILAND'},
{id: 205, iso: 'SE', name: 'SWEDEN'},
{id: 206, iso: 'CH', name: 'SWITZERLAND'},
{id: 207, iso: 'SY', name: 'SYRIAN ARAB REPUBLIC'},
{id: 208, iso: 'TW', name: 'TAIWAN'},
{id: 209, iso: 'TJ', name: 'TAJIKISTAN'},
{id: 210, iso: 'TZ', name: 'TANZANIA'},
{id: 211, iso: 'TH', name: 'THAILAND'},
{id: 212, iso: 'TL', name: 'TIMOR-LESTE'},
{id: 213, iso: 'TG', name: 'TOGO'},
{id: 214, iso: 'TK', name: 'TOKELAU'},
{id: 215, iso: 'TO', name: 'TONGA'},
{id: 216, iso: 'TT', name: 'TRINIDAD AND TOBAGO'},
{id: 217, iso: 'TN', name: 'TUNISIA'},
{id: 218, iso: 'TR', name: 'TURKEY'},
{id: 219, iso: 'TM', name: 'TURKMENISTAN'},
{id: 220, iso: 'TC', name: 'TURKS AND CAICOS ISLANDS'},
{id: 221, iso: 'TV', name: 'TUVALU'},
{id: 222, iso: 'UG', name: 'UGANDA'},
{id: 223, iso: 'UA', name: 'UKRAINE'},
{id: 224, iso: 'AE', name: 'UNITED ARAB EMIRATES'},
{id: 225, iso: 'GB', name: 'UNITED KINGDOM'},
{id: 226, iso: 'US', name: 'UNITED STATES'},
{id: 227, iso: 'UM', name: 'UNITED STATES MINOR OUTLYING ISLANDS'},
{id: 228, iso: 'UY', name: 'URUGUAY'},
{id: 229, iso: 'UZ', name: 'UZBEKISTAN'},
{id: 230, iso: 'VU', name: 'VANUATU'},
{id: 231, iso: 'VE', name: 'VENEZUELA'},
{id: 232, iso: 'VN', name: 'VIET NAM'},
{id: 233, iso: 'VG', name: 'BRITISH VIRGIN ISLANDS'},
{id: 234, iso: 'VI', name: 'U.S. VIRGIN ISLANDS'},
{id: 235, iso: 'WF', name: 'WALLIS AND FUTUNA'},
{id: 236, iso: 'EH', name: 'WESTERN SAHARA'},
{id: 237, iso: 'YE', name: 'YEMEN'},
{id: 238, iso: 'ZM', name: 'ZAMBIA'},
{id: 239, iso: 'ZW', name: 'ZIMBABWE'}

];



// WEBPACK FOOTER //
// ./src/app/tms/markets.ts